/* import __COLOCATED_TEMPLATE__ from './money-per-unit-field-input.hbs.js'; */
import { bool, not } from '@ember/object/computed';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import { isEmpty, isNone } from '@ember/utils';
import { inject as service } from '@ember/service';
import { measureTextWidth } from '@square/dashboard-utilities/utils/input';
const FOCUS_OUT_PADDING = 16;
const FOCUS_IN_PADDING = 24;

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['money-per-unit-field-input'],
  classNameBindings: ['noAbbreviation:money-per-unit-field-input--no-abbreviation', 'alignRight:money-per-unit-field-input--align-right'],
  formatter: service(),
  // passed in
  unitAbbreviation: null,
  value: null,
  parentField: null,
  onChange: null,
  keyUp: null,
  alignRight: false,
  disabled: false,
  fakeFocusStyle: false,
  onTextDidChange: () => {},
  placeholderOverride: '',
  hasAbbreviation: bool('unitAbbreviation'),
  isEditing: false,
  showAbbreviation: computed('hasAbbreviation', 'value.amount', 'isEditing', function () {
    return this.hasAbbreviation && (this.isEditing || !isNone(this.value?.amount));
  }),
  noAbbreviation: not('showAbbreviation'),
  unitAbbreviationLabel: computed('unitAbbreviation', function () {
    return `/${this.unitAbbreviation}`;
  }),
  placeholder: computed('formatter', 'placeholderOverride', 'unitAbbreviation', 'unitAbbreviationLabel', function () {
    if (!isEmpty(this.placeholderOverride)) {
      return this.placeholderOverride;
    } else {
      return isEmpty(this.unitAbbreviation) ? this.formatter.currency(0) : `${this.formatter.currency(0)}${this.unitAbbreviationLabel}`;
    }
  }),
  setInputWidth(padding = FOCUS_OUT_PADDING) {
    if (!this.alignRight && this.element) {
      const input = this.element.querySelector('.money-per-unit-field-input__input');
      const moneyField = this.element.querySelector('.money-per-unit-field-input__money-field');
      const inputVal = input.value;
      const textWidth = measureTextWidth(inputVal);
      moneyField.style.width = `${textWidth + padding}px`;
    }
  },
  init(...args) {
    this._super(...args);
    scheduleOnce('afterRender', this, this.setInputWidth);
  },
  didUpdateAttrs() {
    this._super();
    scheduleOnce('afterRender', this, this.setInputWidth);
  },
  actions: {
    onMoneyValueChange(newValue) {
      this.set('isEditing', false);
      if (this.onMoneyValueChange) {
        this.onMoneyValueChange(newValue);
      }
    },
    abbreviationClicked() {
      this.element.querySelector('.money-per-unit-field-input__input').focus();
    },
    onFocusIn() {
      this.setInputWidth(FOCUS_IN_PADDING);
      if (this.onFocusIn) {
        this.onFocusIn();
      }
    },
    onFocusOut() {
      if (this.onFocusOut) {
        this.onFocusOut();
      }
    },
    onTextDidChange(...args) {
      this.set('isEditing', true);
      this.setInputWidth(FOCUS_IN_PADDING);
      this.onTextDidChange(...args);
    }
  }
});